import { html, ifDefined, unsafeHTML } from "../../.."
import type { HookFieldGetList_ReturnType } from "../../../global/hooks"
import { HookFieldGetList } from "../../../global/hooks"

import { _GetFieldList, getDisplayValue } from "../../table/helpers"
import { _setFieldFocus } from "../helper"

import { _focusOutHelper } from "./helpers"
import { SYSControlBase } from "./syscontrolbase"

export class SYSOption extends SYSControlBase {
  checkedElement: any
  handleChange(e: Event, value: any) {
    e.stopPropagation()
    e.preventDefault()
    this.actions.ovl.form._ChangeField({
      fieldKey: this.field.fieldKey,
      formState: this.formState,
      value,
      watched: true,
      noRetrigger: true,
    })
  }
  async getUI() {
    let visible = super.InitControl()
    if (visible === false) {
      return undefined
    }

    let field = this.field

    let list = field.list
    let listFn = HookFieldGetList.replace(
      "{subFeature}",
      this.formState.subFeature
    ).replace("{fieldKey}", field.fieldKey)

    let listDataAll: HookFieldGetList_ReturnType = _GetFieldList(
      this.actions.app.features[this.formState.feature].hooks[listFn],
      field.fieldKey,
      this.formState,
      this.formState?.tableDefId,
      /* cachebust = true, because we do not have a trigger like in lists (there it gets busted eg. when user clicks on select button) 
      . if one day it needs caching please reintroduce the timely cache but just for option list type (like 100ms)*/
      true
    )
    let listData = listDataAll.data
    let inline = ""
    if (field.ui.option && field.ui.option.inline) {
      inline = "fd-form-group--inline"
    }

    return html`
      <div
        class="${this.getContainerClass(
          "option",

          this.customInfo.customRowClassContainerName
        )}"
      >
        <ovl-controllabel .props=${() => this.field}> </ovl-controllabel>

        <div
          class="fd-form-group ovl-formcontrol-value __inpfocbox ovl-option-group ${inline} ${this
            .customInfo.customRowClassName}"
          id="${field.id}"
          @focusout=${(e) => _focusOutHelper(e, this.field)}
        >
          ${Object.keys(listData)
            .sort((a, b) =>
              listDataAll.sortFn
                ? listDataAll.sortFn(listData[a], listData[b])
                : 0
            )
            .map((rowKey) => {
              let val = getDisplayValue(
                field.fieldKey,
                { list: field.list, type: field.type, ui: field.ui },
                rowKey,
                this.formState.feature,
                this.formState,
                this.formState?.tableDefId,
                field.list.displayField
              ) //listData[rowKey][list.displayField]
              let id = `${field.id}${rowKey}`
              let checked =
                field.convertedValue === listData[rowKey][list.valueField]
              let readOnly = this.getReadOnly()
              return html`<div>
                <input
                  tabindex=${ifDefined(!this.focusable ? "-1" : undefined)}
                  class="fd-radio ${this.getInputClass(
                    "option",

                    this.customInfo.customRowClassName
                  )}"
                  type="radio"
                  id=${id}
                  name=${id}
                  ?checked=${checked}
                  .checked=${checked}
                  @click=${(e) => e.stopPropagation()}
                  @focus=${() => _setFieldFocus(field, true)}
                  @change=${(e) =>
                    this.handleChange(e, listData[rowKey][list.valueField])}
                  @focusout=${(e) => _setFieldFocus(field, false)}
                  ?disabled=${readOnly}
                />
                <label
                  class="fd-radio__label ovl-formcontrol-optionlabel ovl-formcontrol-optionlabel__${field.fieldKey}"
                  for="${field.id + rowKey}"
                >
                  ${unsafeHTML(val)}
                </label>
              </div> `
            })}
        </div>

        <ovl-controlcustomhint .props=${() => this.field}>
        </ovl-controlcustomhint>
        <ovl-controlvalidationhint .props=${() => this.field}>
        </ovl-controlvalidationhint>
      </div>
    `
  }
  // async afterRender() {
  //   if (this.checkedElement) {
  //     document.getElementById(this.checkedElement).checked = true
  //     this.checkedElement = undefined
  //   }
  // }
}
